import { useTheme } from "next-themes"
import { useEffect } from "react"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  // App-wide: tapping/clicking anywhere on a toast dismisses it immediately.
  // We skip interactive controls (action/close buttons, links) so they still work.
  useEffect(() => {
    const handler = (e) => {
      if (e.target.closest('button, a, [role="button"]')) return;
      if (e.target.closest('[data-sonner-toast]')) toast.dismiss();
    };
    document.addEventListener('pointerdown', handler);
    return () => document.removeEventListener('pointerdown', handler);
  }, []);

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      style={{ cursor: 'pointer' }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:w-[calc(100vw-24px)] group-[.toaster]:max-w-[calc(100vw-24px)] sm:group-[.toaster]:w-auto sm:group-[.toaster]:max-w-md group-[.toaster]:min-h-fit group-[.toaster]:py-3 group-[.toaster]:px-4 group-[.toaster]:items-start",
          title: "group-[.toast]:whitespace-normal group-[.toast]:break-words group-[.toast]:text-sm group-[.toast]:leading-snug",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:whitespace-normal group-[.toast]:break-words",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error: "group-[.toaster]:text-left",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
